import { useScrollLock } from '@/hooks/useScrollLock'
import { useI18n } from '@/i18n'

/**
 * First-visit language picker. Shown once, before a locale cookie exists —
 * see `hasChosenLocale` in the i18n provider. Bilingual by design: the
 * visitor hasn't told us a preference yet, so both languages get equal
 * billing rather than defaulting the copy to Indonesian.
 */
export function LanguagePrompt() {
  const { setLocale, hasChosenLocale } = useI18n()

  useScrollLock(!hasChosenLocale)

  if (hasChosenLocale) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="language-prompt-heading"
      className="fixed inset-0 z-[70] flex items-center justify-center bg-ink/90 p-4 backdrop-blur-sm"
    >
      <div className="w-full max-w-sm rounded-2xl border border-gold/20 bg-ink p-6 text-center shadow-[0_24px_60px_-20px_rgba(0,0,0,0.6)] sm:p-8">
        <p id="language-prompt-heading" className="font-serif text-2xl text-parchment">
          Pilih Bahasa <span className="text-muted">/</span> Choose Language
        </p>
        <p className="mt-2 text-sm text-muted">
          Situs ini tersedia dalam dua bahasa.
          <br />
          This site is available in two languages.
        </p>

        <div className="mt-6 flex flex-col gap-3">
          <button
            type="button"
            autoFocus
            onClick={() => setLocale('id')}
            className="min-h-12 rounded-full bg-gold px-6 text-sm font-medium uppercase tracking-[0.14em] text-ink transition duration-300 ease-[var(--ease-out-soft)] hover:bg-gold-light active:scale-[0.98]"
          >
            Bahasa Indonesia
          </button>
          <button
            type="button"
            onClick={() => setLocale('en')}
            className="min-h-12 rounded-full border border-gold/35 px-6 text-sm font-medium uppercase tracking-[0.14em] text-gold transition duration-300 ease-[var(--ease-out-soft)] hover:border-gold hover:bg-gold/10 active:scale-[0.98]"
          >
            English
          </button>
        </div>
      </div>
    </div>
  )
}
